import { GsFormFieldText, GsFormSchema } from '../../../components';

export const TEXT_FIELD_COMPONENT_SCHEMA: GsFormSchema = {
  fields: [
    {
      formControlName: 'placeholder',
      label: 'formComponents.text.schema.placeholder.label',
      type: 'text',
      inputType: 'text',
      description: 'formComponents.text.schema.placeholder.description',
      default: ''
    } as GsFormFieldText
  ]
};
